const commands= [
    {
        id:0,
        command: '/addstr',
        description: 'Comando que tiene como función agregar puntos a la habilidad de fuerza.',
        method: '/addstr [puntos en fuerza]',
        requirement: '',
        cost: '100 mil de zen.',
        condition: 'Puedes agregar hasta un máximo de 999 puntos a la vez.',
        show:false,
        color: 'is-success',
        extra: ""
    },
    {
        id:1,
        command: '/addagi',
        description: 'Comando que tiene como función agregar puntos a la habilidad de agilidad.',
        method: '/addagi [puntos en agilidad]',
        requirement: '',
        cost: '100 mil de zen.',
        condition: 'Puedes agregar hasta un máximo de 999 puntos a la vez.',
        show:false,
        color: 'is-success',
        extra: ""
    },
    {
        id:2,
        command: '/addvit',
        description: 'Comando que tiene como función agregar puntos a la habilidad de vida.',
        method: '/addvit [puntos en vida]',
        requirement: '',
        cost: '100 mil de zen.',
        condition: 'Puedes agregar hasta un máximo de 999 puntos a la vez.',
        show:false,
        color: 'is-success',
        extra: ""
    },
    {
        id:3,
        command: '/addene',
        description: 'Comando que tiene como función agregar puntos a la habilidad de energia.',
        method: '/addene [puntos en energia]',
        requirement: '',
        cost: '100 mil de zen.',
        condition: 'Puedes agregar hasta un máximo de 999 puntos a la vez.',
        show:false,
        color: 'is-success',
        extra: ""
    },
    {
        id:4,
        command: '/move',
        description: 'Comando que tiene como función viajar a otro mapa.',
        method: '/move [nombre del mapa]',
        requirement: 'Empezando desde nivel 50 (Varía según del mapa).',
        cost: 'Empezando desde 50k zen (Varía según el nivel del mapa).',
        condition: '',
        show:false,
        color: 'is-dark',
        extra: ""
    },
    {
        id:5,
        command: '/time',
        description: 'Comando que tiene como función mostrar la hora actual del juego.',
        method: '/time',
        requirement: '',
        cost: '',
        condition: '',
        show:false,
        color: 'is-dark',
        extra: ""
    },
    {
        id:6,
        command: '/salir',
        description: 'Comando que tiene como función forzar la desconexión del jugador sin la espera de los 5 segundos.',
        method: '/salir',
        requirement: '',
        cost: '',
        condition: '',
        show:false,
        color: 'is-dark',
        extra: ""
    },
    {
        id:7,
        command: '/ping',
        description: 'Comando que tiene como función visualizar la velocidad de tu conexión de internet.',
        method: '/ping',
        requirement: '',
        cost: '',
        condition: '',
        show:false,
        color: 'is-dark',
        extra: ""
    },
    {
        id:8,
        command: '/post',
        description: 'Comando que tiene como función mandar un mensaje global, el cual puede ser visto por todos los jugadores del servidor.',
        method: '/post [mensaje]',
        requirement: 'Personaje con un nivel de 50',
        cost: '500 mil de zen.',
        condition: '',
        show:false,
        color: 'is-link',
        extra: ""
    },
    {
        id:9,
        command: '/compra',
        description: 'Al igual que el comando /post, este comando tiene como finalidad enviar un mensaje global, con la diferencia de que se utiliza para comprar objetos.',
        method: '/compra [mensaje de compra]',
        requirement: 'Personaje con un nivel de 50',
        cost: '1 millón de zen.',
        condition: 'Solo para jugadores con Pase VIP.',
        show:false,
        color: 'is-link',
        extra: ""
    },
    {
        id:10,
        command: '/venta',
        description: 'Al igual que el comando /post, este comando tiene como finalidad enviar un mensaje global, con la diferencia de que se utiliza para vender objetos',
        method: '/venta [mensaje de venta]',
        requirement: 'Personaje con un nivel de 50',
        cost: '1 millón de zen.',
        condition: 'Solo para jugadores con Pase VIP.',
        show:false,
        color: 'is-link',
        extra: ""
    },
    {
        id:11,
        command: '/marry',
        description: 'Comando que tiene como función casar a dos jugadores en el juego.',
        method: '/marry, /accept, /divorce, /marrystatus, /tracemarry, /getmarry',
        requirement: 'Personaje con un nivel de 320, un corazón.',
        cost: '150 millones de zen',
        condition: 'Encontrarse ambos jugadores en la iglesia de davias, coordenadas del esposo: 209,16 | coordenadas de la esposa: 210,16.',
        show:false,
        color: 'is-light',
        extra: "El comando marry va de la mano con los otros comandos, que funcionan para aceptar casarse, para divorciarse, para ver el estado del matrimonio y para ir a donde se encuentra la pareja respectivamente."
    },
    // {
    //     id:12,
    //     command: '/reset',
    //     description: 'Comando que tiene como función reiniciar el nivel del personaje a 1, y sus parámetros (fuerza, agilidad, energia y vida) a los valores de inicio.',
    //     method: '/reset',
    //     requirement: 'Personaje con un nivel de 500',
    //     cost: 'Empezando desde 10 millones de zen, agregando 10 millones más por cada reset que el jugador haga. (10kk costo por 1 reset, 20kk costo por 2 resets... etc)',
    //     condition: '',
    //     show:false,
    //     color: 'is-warning',
    //     extra: "El personaje recibirá 500 puntos por cada reset que haga. (1k puntos por 1 reset, 2k puntos por 2 resets... etc)"
    // },
    {
        id:13,
        command: '/pkclear',
        description: 'Comando que tiene como función quitar el estado de "asesino" del personaje.',
        method: '/pkclear',
        requirement: '',
        cost: '5 millones de zen por asesinato.',
        condition: 'Mientras más asesinatos tiene el personaje, más costoso será el comando.',
        show:false,
        color: 'is-danger',
        extra: ""
    },
    {
        id:14,
        command: '/vault',
        description: 'Comando que tiene como función cambiar entre tus bóvedas (Vaults).',
        method: '/vault [número de bóveda]',
        requirement: 'El jugador debe tener al menos 1 reset para utilizar este comando.',
        cost: '10 mil de zen',
        condition: 'Puede abrir hasta un máximo de 5 bóvedas (Vaults)',
        show:false,
        color: 'is-info',
        extra: ""
    },
    {
        id:15,
        command: '/guild',
        description: 'Comando que tiene como función mandar una petición a otro jugador para unirse a un gremio (Guild).',
        method: '/guild',
        condition: 'El otro jugador debe ser el Maestro del Gremio (GuildMaster). Debe seleccionar al otro jugador mientras envía el comando.',
        show:false,
        requirement:'',
        cost:'',
        color: 'is-primary',
        extra: "El jugador solo puede pertenecer a un solo Gremio."
    },
    {
        id:16,
        command: '/war',
        description: 'Comando que tiene como función retar a otro gremio a una guerra (Guild War).',
        method: '/war [Nombre del Gremio Enemigo]',
        condition: 'Debes ser el Maestro del gremio para iniciar una guerra.',
        show:false,
        requirement:'',
        cost:'',
        color: 'is-primary',
        extra: "La guerra solo se efectuara si el otro maestro de gremio esta conectado en el juego y acepta la petición."
    },
    {
        id:17,
        command: '/party',
        description: 'Comando que tiene como función mandar una petición a otro jugador para crear o unirse a un grupo (Party).',
        method: '/party',
        condition: 'Debe seleccionar al otro jugador mientras envía el comando.',
        show:false,
        requirement:'',
        cost:'',
        color: 'is-danger',
        extra: ""
    },
    {
        id:19,
        command: '/trade',
        description: 'Comando que tiene como función iniciar un intercambio con otro jugador.',
        method: '/trade',
        condition: 'Debe seleccionar al otro jugador mientras envía el comando.',
        show:false,
        requirement:'',
        cost:'',
        color: 'is-dark',
        extra: "El intercambio solo sera efectuado si ambas partes aceptan."
    },
    {
        id:20,
        command: '/actividad',
        description: 'Comando que tiene como función visualizar cual es la actividad actual del jugador y su progreso.',
        method: '/actividad',
        condition: '',
        show:false,
        requirement:'',
        cost:'',
        color: 'is-info',
        extra: ""
    },
    {
        id:21,
        command: '/datos',
        description: 'Comando que tiene como función visualizar las características del personaje.',
        method: '/datos',
        condition: '',
        show:false,
        requirement:'',
        cost:'',
        color: 'is-info',
        extra: ""
    },
    {
        id:25,
        command: '/grandreset',
        description: 'Comando que tiene como función reiniciar el nivel y los resets del personaje a 1, junto a sus parámetros (fuerza, agilidad, energia y vida) a los valores de predeterminados.',
        method: '/grandreset',
        requirement: 'Personaje con un nivel de 500 (400 VIP) y 100 resets (90 VIP).',
        cost: 'Empezando desde 100 millones de zen (50millones VIP), agregando 100 millones más por cada Grandreset que el jugador haga. (100kk costo por 1 Grandreset, 200kk costo por 2 Grandresets... etc)',
        condition: 'Debe de tener 10 chaos a su dispoción en el inventario.',
        show:false,
        color: 'is-warning',
        extra: "El personaje recibirá 10.000 puntos por cada Grandreset que haga. (10k puntos por 1 Grandreset, 20k puntos por 2 Grandresets... etc). El jugador recibirá 10mil (12mil VIP) créditos adicionales por cada Grandreset que haga."
    },
]

export default commands